export const dataHooks = {
    title: 'helper-content-title',
    body: 'helper-content-body',
    actionButton: 'helper-content-action-button',
    image: 'helper-content-image',
    footer: 'helper-content-footer',
};
export const actionButtonTheme = {
    standard: 'standard',
    white: 'white',
    premium: 'premium',
    lightPrimary: 'lightPrimary',
    standardPrimary: 'standardPrimary',
};
//# sourceMappingURL=constants.js.map